import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStudentDashboard } from '../../api/studentApi';
import StudentSidebar from '../../components/student/StudentSidebar';
import PageLoader from '../../components/common/PageLoader';
import { toTitleCase } from '../../utils/format';

export default function StudentDashboard() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getStudentDashboard().then(setData).catch(console.error).finally(() => setLoading(false));
  }, []);

  const { student, stats, courses } = data || {};
  const certs = stats?.certificates ?? 0;

  return (
    <div className="app">
      <StudentSidebar course={null} modules={[]} currentModuleId={null} />
      <div className="main" style={{ animation: 'fi .3s ease' }}>

        <div className="ph">
          <div>
            <div className="bc">Student / Dashboard</div>
            <div className="pt">
              {student ? `Welcome back, ${toTitleCase(student.full_name.split(' ')[0])} 👋` : 'Dashboard'}
            </div>
            <div className="ps">Continue where you left off</div>
          </div>
        </div>

        <div className="body">
          {loading ? (
            <PageLoader />
          ) : (<>
            {/* Stat cards */}
            <div className="stats">
              <div className="sc" style={{ animation: 'slideUp .3s ease both' }}>
                <div className="sc-l">Courses</div>
                <div className="sc-v">{stats.courses_enrolled}</div>
                <div className="sc-s" style={{ color: 'var(--green)' }}>Enrolled</div>
              </div>
              <div className="sc" style={{ animation: 'slideUp .3s ease both', animationDelay: '.05s' }}>
                <div className="sc-l">Modules Done</div>
                <div className="sc-v">{stats.modules_done}/{stats.modules_total}</div>
                {stats.modules_total > 0 && (
                  <div className="sc-bar">
                    <div className="sc-fill" style={{ width: `${Math.round(stats.modules_done / stats.modules_total * 100)}%`, background: 'var(--yellow)' }} />
                  </div>
                )}
              </div>
              <div className="sc" style={{ animation: 'slideUp .3s ease both', animationDelay: '.1s' }}>
                <div className="sc-l">Assignments</div>
                <div className="sc-v">{stats.assignments_submitted}/{stats.assignments_total}</div>
                {stats.assignments_total > 0 && (
                  <div className="sc-bar">
                    <div className="sc-fill" style={{ width: `${Math.round(stats.assignments_submitted / stats.assignments_total * 100)}%`, background: 'var(--orange)' }} />
                  </div>
                )}
              </div>
              <div className="sc" style={{ animation: 'slideUp .3s ease both', animationDelay: '.15s' }}>
                <div className="sc-l">Certificates</div>
                <div className="sc-v">{certs}</div>
                <div className="sc-s" style={{ color: certs ? 'var(--green)' : 'var(--muted)' }}>
                  {certs ? 'Earned' : 'In progress'}
                </div>
              </div>
            </div>

            {/* My Courses */}
            <div className="card">
              <div className="ct">My Courses</div>
              {courses.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '32px', color: 'var(--muted)', fontSize: 13 }}>
                  You are not enrolled in any courses yet.
                </div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(300px,1fr))', gap: 14 }}>
                  {courses.map((c, i) => (
                    <div
                      key={c.course_id}
                      className="cc"
                      style={{ animation: 'slideUp .3s ease both', animationDelay: `${i * 0.1}s` }}
                      onClick={() => navigate(`/student/courses/${c.course_id}`)}
                    >
                      <div className="cc-thumb" style={{ background: `linear-gradient(135deg,${c.accent_color}22,${c.accent_color}44)` }}>
                        <span style={{ fontSize: 44 }}>{c.emoji}</span>
                        <div className="cc-tag">
                          {c.assignments_count} assignment{c.assignments_count !== 1 ? 's' : ''}
                        </div>
                      </div>
                      <div className="cc-body">
                        <div className="cc-title">{toTitleCase(c.title)}</div>
                        <div className="cc-meta">
                          {toTitleCase(c.instructor || 'Instructor')} · {c.modules_done}/{c.modules_total} modules completed
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 }}>
                          <span style={{ fontSize: 11.5, color: 'var(--muted)' }}>{c.progress}% complete</span>
                          <div style={{ display: 'flex', gap: 6 }}>
                            {c.certificate_code && (
                              <span className="b b-g">🎓 Certified</span>
                            )}
                            <button
                              className="btn btn-p btn-sm"
                              onClick={e => { e.stopPropagation(); navigate(`/student/courses/${c.course_id}`); }}
                            >
                              Continue →
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>)}
        </div>
      </div>
    </div>
  );
}
